import { Seo } from "@trueskin-web/components"
import { useTranslation } from "@trueskin-web/translations"

import imageAfter from "../../../../images/plan-selection/christina-after.webp"
import imageBefore from "../../../../images/plan-selection/christina-before.webp"
import MoneyBack from "../../../components/choose-plan/components/money-back"
import PageHeader from "../../../components/choose-plan/components/page-header"
import Testimonials from "../../../components/choose-plan/components/testimonials"
import FAQs from "../../shared/faqs"
import Products from "../components/products"
import { faq, plansV2 } from "../resources"

import Plans from "./plans"

const SubscriptionTiersV2 = () => {
  const { t } = useTranslation()

  return (
    <div sx={{ maxWidth: "468px", mx: "auto" }}>
      <Seo title={t("ChoosePlan.seoTitle")} />

      <PageHeader
        headline={"Haut ist individuell. Dein FORMEL SKIN-Set auch."}
        sx={{
          mt: 4,
          columnGap: 5,
          "& h2": {
            lineHeight: "smallerHeading",
          },
        }}
      />

      <Products />

      <Plans resources={plansV2} />

      <MoneyBack sx={{ background: "lightBlue" }} />

      <Testimonials
        headline="Echte Menschen – Echte Erfolge"
        subline="Nach nur 6–8 Behandlungswochen feiern
unsere Patient:innen sichtbare Erfolge."
        images={[imageBefore, imageAfter]}
        labels={["Vorher", "Nach 2 Monaten"]}
        customer={
          <>
            <span sx={{ fontWeight: "bold" }}>Christina,</span> Akne-Patientin
            bei FORMEL SKIN
          </>
        }
      />

      <FAQs
        title="FAQs"
        items={faq}
        sx={{
          mb: 7,
        }}
      />
    </div>
  )
}

export default SubscriptionTiersV2
